export default __webpack_public_path__ + "static/media/Untitled.4a946bfd.png";